import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { SetScene, SetSceneIndex, SetSegment, } from '../../training.actions';
import { TrainingState } from '../../training.model';
import { goToAct, pause, play, playChanged, sceneIndex, setSegment, taskIndex } from '../../training.selectors';
import { TrainingService } from '../../training.service';

@Component({
  selector: 'segments',
  templateUrl: './segments.component.html',
  styleUrls: ['./segments.component.scss']
})
export class SegmentsComponent {
  @ViewChild('container') container: ElementRef | undefined;


  @Output() seek: EventEmitter<number> = new EventEmitter();

  lines: number[] = []
  pix_per_sec: number = 0

  lines_delta: number = 10
  box_width: number = 100

  left_b: number = 100

  left_h: number = 98 //also used for the left text
  right_t: number = 98
  right_h: number = 219
  width_b: number = 20
  num_scenes: number = 0
  scenes: any[] = []
  scene: any = {}
  scene_s: number = 0
  scene_e: number = 0
  scene_pw: number = 0
  name: string = ""
  subscriptions: any[] = []

  act: string = "intro"
  colors: any = {
    intro: "#A9D6EB",
    describe: "#88D4AB",
    problems: "#F49899"
  }
  color: string = "#A9D6EB"
  border: string = "1px solid #A9D6EB"
  scene_pc: string = "#A9D6EB60"
  bcolor: string = "#A9D6EB50"
  movie_duration: number = 0
  _curr_time: number = 0
  inst: string = "Play scene"
  // @Input() set duration(d: number) {
  //   if (this.movie_duration != d) {
  //     this.movie_duration = d
  //     this.setMovieScale()
  //   }
  // }
  @Input() set curr_time(t: number) {

    this._curr_time = t
    let delta_sec = t - this.scene_s
    if (delta_sec < 0) {
      delta_sec = 0
    }
    if ((this.scene_s + delta_sec) > this.scene_e) {
      delta_sec = this.scene_e - this.scene_s
    }
    this.scene_pw = delta_sec * this.pix_per_sec

  }
  bPlaying: boolean = false
  @ViewChild('segment') segment: ElementRef | undefined;
  pointer_id: any //to capture the mouse

  constructor(
    public trainingStore: Store<TrainingState>,
    public training_service: TrainingService,
  ) {
    console.log("Segments")
    this.subscriptions.push(this.trainingStore.select(play).subscribe((num: number) => {
      if (num) {
        this.bPlaying = true
        if (this.act == 'intro') {  //If we are in intro
          if (this.scene.index == this.num_scenes - 1)
            if (this.scene.end <= this.movie_duration) {
              this.inst = "Pause to set scene end"
              return
            }
        }
        this.inst = ""
      }
    }))
    this.subscriptions.push(this.trainingStore.select(pause).subscribe((num: number) => {
      if (num) {
        this.bPlaying = false
        if (this.act == 'intro') {  //If we are in intro
          if (this.scene.index == this.num_scenes - 1) { //and the last scene,
            this.scene_e = this._curr_time
            this.setScene(this.scene_s, this.scene_e)
            this.inst = "Save the scene"
            //then we can set the scene.end
          }
        }
      }
    }))
    this.subscriptions.push(this.trainingStore.select(goToAct).subscribe((act: any) => {
      console.log("act " + act)
      this.act = act
      this.color = this.colors[act]
      this.bcolor = this.color + "50"
      this.scene_pc = this.color + "60"
      this.border = "1px solid " + this.color
      this.setInScene()
    }))
    this.subscriptions.push(this.trainingStore.select(setSegment).subscribe((segment: any) => {
      this.setScene(segment.start, segment.end)
    }))

  }
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) { //aspect ratio is 1280, 720
    setTimeout(() => this.setMovieScale())
  }
  my_play: any = {}
  task_index: number = -1;
  scene_index: number = -1;
  async setInScene() {

    if (this.my_play && this.my_play.tasks && this.task_index >= 0) {
      let task = this.my_play.tasks[this.task_index]
      if (task && task.scenes && this.scene_index >= 0) {
        this.scenes = task.scenes
        this.scene = task.scenes[this.scene_index]
        if (this.scene && this.scene.name) {
          this.name = this.scene.name
          let movie = task.play_movies[this.scene.movie_name]
          if (movie) {
            this.num_scenes = task.scenes.length
            this.movie_duration = movie.duration
            let inst = ""
            if (this.act == 'intro') {  //If we are in intro
              if (this.scene_index == this.num_scenes - 1)
                if (this.scene.end <= this.movie_duration) {
                  inst = "Pause to set scene end"
                }
            }
            setTimeout(() => {
              this.inst = inst
            })
            if (this.setMovieScale()) {
              this.setScene(this.scene.start, this.scene.end)
            }
          }
        }
      }
    }

  }
  ngAfterViewInit() {
    this.subscriptions.push(this.trainingStore.select(playChanged).subscribe((play: any) => {
      console.log("playChanged " + new Date())
      if (play && play._id) {
        setTimeout(() => {
          this.my_play = play
          this.setInScene()
        })
      }
    }))
    this.subscriptions.push(this.trainingStore.select(taskIndex).subscribe((index: number) => {
      this.task_index = index
      this.setInScene()
    }))
    this.subscriptions.push(this.trainingStore.select(sceneIndex).subscribe((index: number) => {
      this.scene_index = index
      this.setInScene()
    }))

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  setMovieScale() {
    console.log("<-- setMovieScale")
    let cont_width = 0
    if (this.container) {
      cont_width = this.container.nativeElement.clientWidth
    } else {
      return
    }

    if (this.movie_duration > 0 && this.movie_duration < 1200) {
      let num_lines
      let i = 0
      do {
        i++
        num_lines = Math.ceil((this.movie_duration) / i)
        this.lines_delta = cont_width / num_lines
      } while (this.lines_delta < 10 && i < 50)
      if (i > 40) {
        console.error("setMovieScale watch dog")
        return false
      }


      //We want to make sure that there are at least 10 pixels between lines
      this.pix_per_sec = cont_width / this.movie_duration
      // this.lines_delta = 10
      this.box_width = num_lines * this.lines_delta
      this.lines = []
      for (let i = 0; i <= num_lines; i++) {
        this.lines.push((i * this.lines_delta) - 1)
      }
      this.width_b = this.right_h - this.left_h - 1
      this.right_t = cont_width - this.right_h + 5
    }
    console.log("setMovieScale -->")
    return true
  }
  setScene(scene_s: number, scene_e: number) {
    setTimeout(() => {
      this.scene_pw = 0
      this.scene_s = scene_s
      this.scene_e = scene_e
      this.left_b = this.pix_per_sec * this.scene_s
      this.left_h = this.left_b - 2
      let right = this.pix_per_sec * this.scene_e

      this.width_b = right - this.left_b
      this.right_h = this.left_h + this.width_b + 1
      if (this.container) {
        this.right_t = this.container.nativeElement.clientWidth - this.right_h + 5
      } else {
        this.right_t = 940 - this.right_h + 5
      }
    })
  }
  startX: number = -1
  prev_l: number = -100
  prev_r: number = -1
  onLhDown($event: any) {
    this.startX = $event.x
    this.prev_l = this.left_h
    if (this.segment) {
      this.pointer_id = $event.pointerId
      this.segment.nativeElement.setPointerCapture(this.pointer_id)
    }
  }
  onRhDown($event: any) {
    this.startX = $event.x
    this.prev_r = this.right_h
    if (this.segment) {
      this.pointer_id = $event.pointerId
      this.segment.nativeElement.setPointerCapture(this.pointer_id)
    }
  }

  onMouseMove($event: any) {
    if (this.startX >= 0) {
      let delta = $event.x - this.startX
      if (this.prev_l >= -50) {
        this.left_h = this.prev_l + delta
        this.left_b = this.left_h + 2
        this.scene_s = this.left_b / this.pix_per_sec
        this.width_b = this.right_h - this.left_h - 1

      } else if (this.prev_r >= 0) {
        this.right_h = this.prev_r + delta
        this.width_b = this.right_h - this.left_h - 1
        this.scene_e = (this.right_h / this.pix_per_sec)// - this.scene_s
        this.right_t = this.box_width - this.right_h + 5

      }
    }
  }
  onMouseUp($event: any) {
    if (this.prev_l >= 0) {
      this.seek.emit(this.scene_s)
    } else if (this.prev_r >= 0) {
      this.seek.emit(this.scene_e)
    }
    this.resetMove()
    if (this.segment) {
      this.pointer_id = $event.pointerId
      this.segment.nativeElement.releasePointerCapture(this.pointer_id)
      this.pointer_id = undefined
    }
    //If we are not in act == intro or we are at the end, change the instruction
    if (this.act == 'intro' && this.scene.index == this.num_scenes - 1) {
      this.inst = "Segment task into steps"
    } else {
      this.inst = ""
    }
    this.training_service.setSegment(this.scene_s, this.scene_e)
  }
  resetMove() {
    this.prev_l = -100
    this.prev_r = -1
    this.startX = -1
  }

  save() {
    this.trainingStore.dispatch(new SetScene(this.name, this.scene_s, this.scene_e))
    this.scene_pw = 0
  }

  onClick($event: any) {
    $event.stopPropagation()
    let delta = $event.layerX - this.startX
    let point = this.left_h + delta
    let seek_to = point / this.pix_per_sec
    // this.scene_pw = point - this.left_b done when curr_time is updated
    this.seek.emit(seek_to)
  }

  selSceneByPoin($event: any) {
    let delta = $event.layerX - this.startX
    let point = delta
    let seek_to = point / this.pix_per_sec
    for (let i = 0; i < this.scenes.length; i++) {
      let scene = this.scenes[i]
      if (scene.start < seek_to && scene.end > seek_to) {
        this.trainingStore.dispatch(new SetSceneIndex(i))
        return
      }
    }
  }
}
